import { Avatar, Stack, Typography } from '@mui/material';
import { Icon, IconSize } from '@shared/icons';

interface PreviewProductProps {
  title: string;
  image?: string;
  detail: string;
}

const PreviewProduct = ({ title, image, detail }: PreviewProductProps) => {
  return (
    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flex: 1, minWidth: 0, px: 2 }} >
      {image ? (
        <Avatar variant="rounded" src={image} alt="" sx={{ border: 1, borderColor: 'divider' }
        } />) : (
        <Avatar variant="rounded" sx={{ border: 1, borderColor: 'divider', backgroundColor: 'divider' }}/>
      )}

      <Stack direction="column" spacing={0.0} sx={{ minWidth: 0 }}>
        <Typography variant="body2" noWrap>{title}</Typography>
        {detail && <Typography variant="caption" color="text.secondary" noWrap>{detail}</Typography>}
      </Stack>
    </Stack>
  );

};


export default PreviewProduct;
